import { render, staticRenderFns } from "./ImportXmlNfeDetails.vue?vue&type=template&id=88228896&scoped=true"
import script from "./ImportXmlNfeDetails.vue?vue&type=script&lang=js"
export * from "./ImportXmlNfeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88228896",
  null
  
)

export default component.exports